import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import Hero from '../components/home/Hero';
import FeaturedServices from '../components/home/FeaturedServices';
import Button from '../components/ui/Button';
import { ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div data-id="element-441">
      <Hero data-id="element-442" />
      <FeaturedServices data-id="element-443" />
      {/* About Section */}
      <section className="py-20 bg-neutral-light/50" data-id="element-444">
        <div className="container mx-auto px-4 md:px-6" data-id="element-445">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-446">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-447">
              <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Toronto skyline with business professionals" className="rounded-lg shadow-lg w-full h-auto object-cover max-h-[500px]" data-id="element-448" />
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6
          }} data-id="element-449">
              <h2 className="text-3xl md:text-4xl font-display font-bold mb-6" data-id="element-450">
                Toronto's Premier <br data-id="element-451" />
                <span className="text-toronto-blue" data-id="element-452">
                  Market Research Agency
                </span>
              </h2>
              <p className="text-lg text-neutral-dark/80 mb-6" data-id="element-453">
                For over 15 years, Market Research Toronto has been delivering
                actionable insights to businesses, organizations, and government
                agencies seeking to understand Toronto's unique consumer
                landscape.
              </p>
              <ul className="space-y-3 mb-8" data-id="element-454">
                {['Multicultural research specialists', 'Bilingual research capabilities (English/French)', 'Proprietary research methodologies', 'ISO 20252 certified for quality standards'].map((item, index) => <li key={index} className="flex items-start" data-id="element-455">
                    <CheckCircleIcon className="text-toronto-blue mr-2 mt-1 flex-shrink-0" size={18} data-id="element-456" />
                    <span data-id="element-457">{item}</span>
                  </li>)}
              </ul>
              <Button variant="primary" data-id="element-458">
                About Our Company <ArrowRightIcon size={16} className="ml-2" data-id="element-459" />
              </Button>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Case Studies Preview */}
      <section className="py-20 bg-white" data-id="element-460">
        <div className="container mx-auto px-4 md:px-6" data-id="element-461">
          <div className="text-center mb-12" data-id="element-462">
            <motion.h2 initial={{
            opacity: 0,
            y: -20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="text-3xl md:text-4xl font-display font-bold mb-4" data-id="element-463">
              Featured <span className="text-toronto-blue" data-id="element-464">Case Studies</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="text-lg text-neutral-dark/80 max-w-2xl mx-auto" data-id="element-465">
              Explore how our research has helped organizations make data-driven
              decisions and achieve measurable results.
            </motion.p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-466">
            {[{
            title: 'Toronto Raptors Fan Culture',
            image: 'https://images.unsplash.com/photo-1504450758481-7338eba7524a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
            category: 'Sports & Entertainment'
          }, {
            title: 'Consumer Behavior in Urban Cores Post-COVID',
            image: 'https://images.unsplash.com/photo-1573164574572-cb89e39749b4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
            category: 'Urban Planning'
          }, {
            title: 'Diversity in Toronto Art Engagement',
            image: 'https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1160&q=80',
            category: 'Arts & Culture'
          }].map((study, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.5
          }} className="group" data-id="element-467">
                <div className="relative overflow-hidden rounded-lg shadow-md h-[300px]" data-id="element-468">
                  <img src={study.image} alt={study.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-469" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex flex-col justify-end p-6 text-white" data-id="element-470">
                    <span className="text-sm font-medium text-toronto-blue bg-white/90 px-2 py-1 rounded-full inline-block mb-2" data-id="element-471">
                      {study.category}
                    </span>
                    <h3 className="text-xl font-semibold" data-id="element-472">{study.title}</h3>
                  </div>
                </div>
              </motion.div>)}
          </div>
          <div className="text-center mt-12" data-id="element-473">
            <Button variant="outline" data-id="element-474">View All Case Studies</Button>
          </div>
        </div>
      </section>
      {/* CTA Section */}
      <section className="py-20 bg-toronto-blue text-white" data-id="element-475">
        <div className="container mx-auto px-4 md:px-6" data-id="element-476">
          <div className="max-w-3xl mx-auto text-center" data-id="element-477">
            <motion.h2 initial={{
            opacity: 0,
            y: -20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="text-3xl md:text-4xl font-display font-bold mb-6" data-id="element-478">
              Ready to Gain Powerful Market Insights?
            </motion.h2>
            <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="text-xl mb-8" data-id="element-479">
              Partner with Market Research Toronto to unlock data-driven
              strategies that deliver results in Toronto's diverse marketplace.
            </motion.p>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.3,
            duration: 0.5
          }} className="flex flex-wrap gap-4 justify-center" data-id="element-480">
              <Button variant="secondary" size="lg" data-id="element-481">
                Schedule a Consultation
              </Button>
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-482">
                Contact Us
              </Button>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;